module.exports = __webpack_public_path__ + "img/9788998791612.1d281cb0.jpg";